import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ImageBlock } from '../../../model';

@Component({
  selector: 'dojo-image-block-renderer',
  template: `
    <figure [class]="alignmentClass()">
      <img [src]="block().src" [alt]="block().alt ?? ''" [title]="block().title ?? ''" [ngStyle]="imageStyle()" />
      @if (block().caption) {
        <figcaption class="mt-2 text-sm text-neutral-500">{{ block().caption }}</figcaption>
      }
    </figure>
  `,
  styles: `
    :host {
      @apply block my-4;
    }

    figure {
      @apply flex flex-col;

      &.align-left {
        @apply items-start;
      }

      &.align-center {
        @apply items-center;
      }

      &.align-right {
        @apply items-end;
      }
    }

    img {
      @apply rounded max-w-full h-auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle],
})
export class ImageBlockRendererComponent {
  readonly block = input.required<ImageBlock>();

  readonly alignmentClass = computed(() => {
    const align = this.block().align ?? 'center';
    return `align-${align}`;
  });

  readonly imageStyle = computed(() => {
    const block = this.block();
    const style: Record<string, string> = {};
    if (block.width !== undefined) {
      style['width'] = `${block.width}px`;
    }
    if (block.height !== undefined) {
      style['height'] = `${block.height}px`;
    }
    return style;
  });
}
